export default "__VITE_ASSET__e0065bf3__"